<app-home-dashboard-skeleton *ngIf="loading"></app-home-dashboard-skeleton>

<main class="home-dashboard" [hidden]="loading">
    <header class="home-header">
        <div>
            <p class="eyebrow">{{dashboardLabel}}</p>
            <h1>{{greeting}}{{displayName ? ', ' + displayName : ''}}</h1>
            <p class="home-summary">
                {{todaysCheckrides.length}} checkride{{todaysCheckrides.length === 1 ? '' : 's'}} today
                <span aria-hidden="true">&middot;</span>
                {{attentionTaskCount}} item{{attentionTaskCount === 1 ? '' : 's'}} need your attention
            </p>
        </div>
        <nav class="header-actions" [attr.aria-label]="dashboardLabel + ' shortcuts'">
            <a class="secondary-action" [routerLink]="calendarRoute"><i class="fa fa-calendar"></i> Calendar</a>
            <a class="primary-action" [routerLink]="checkrideRoute"><i class="fa fa-list"></i> Checkrides</a>
        </nav>
    </header>

    <section class="kpi-panel" [attr.aria-label]="dashboardLabel + ' performance summary'">
        <app-report-dashboard-group-host *ngIf="kpiScopeFilters && tileDrillDownRoute" [useHomeSkeleton]="true" [dashboardGroupKey]="dashboardGroupKey" [scopeFilters]="kpiScopeFilters" [expressionContext]="expressionContext" [tileDrillDownRoute]="tileDrillDownRoute"></app-report-dashboard-group-host>
    </section>

    <div class="dashboard-layout">
        <div class="schedule-column">
            <section class="dashboard-card schedule-card" [attr.aria-busy]="checkridesLoading">
                <header class="section-header">
                    <div>
                        <p class="eyebrow">Schedule</p>
                        <h2>{{selectedScheduleDay === 'today' ? 'Today' : 'Tomorrow'}}</h2>
                    </div>
                    <div class="schedule-header-actions">
                        <div class="day-filter" role="tablist" aria-label="Schedule day">
                            <button type="button" role="tab" [class.active]="selectedScheduleDay === 'today'" [attr.aria-selected]="selectedScheduleDay === 'today'" (click)="selectScheduleDay('today')">
                                Today <span>{{todaysCheckrides.length}}</span>
                            </button>
                            <button type="button" role="tab" [class.active]="selectedScheduleDay === 'tomorrow'" [attr.aria-selected]="selectedScheduleDay === 'tomorrow'" (click)="selectScheduleDay('tomorrow')">
                                Tomorrow <span>{{tomorrowsCheckrides.length}}</span>
                            </button>
                        </div>
                        <a [routerLink]="calendarRoute">View calendar</a>
                    </div>
                </header>

                <ng-container *ngIf="checkridesLoading" [ngTemplateOutlet]="checkrideSkeleton"
                    [ngTemplateOutletContext]="{ compact: false }"></ng-container>
                <p class="alert alert-danger" role="alert" *ngIf="checkridesError">{{checkridesError}}</p>
                <div class="empty-state" *ngIf="!checkridesLoading && !checkridesError && visibleCheckrides.length === 0">
                    <i class="fa fa-calendar-check"></i>
                    <div>
                        <strong>No checkrides scheduled {{selectedScheduleDay}}</strong>
                        <span>Your next seven days are shown below.</span>
                    </div>
                </div>

                <ng-container *ngIf="!checkridesLoading && !checkridesError">
                <app-dashboard-checkride-card *ngFor="let card of visibleCheckrides"
                    [examinerLabel]="examinerLabel" [showFlightSchool]="showFlightSchool"
                    [card]="card" [checkrideRoute]="checkrideRoute" [showPlanOfActionActions]="showPlanOfActionActions" [expanded]="expandedCheckrideId === card.id"
                    (expandedChange)="expandedCheckrideId = $event ? card.id : null">
                </app-dashboard-checkride-card>
                </ng-container>
            </section>

            <section class="dashboard-card upcoming-card" [attr.aria-busy]="checkridesLoading">
                <header class="section-header compact">
                    <div>
                        <p class="eyebrow">Coming up</p>
                        <h2>Next 7 days</h2>
                    </div>
                    <span>{{upcomingCheckrides.length}} scheduled</span>
                </header>

                <ng-container *ngIf="checkridesLoading" [ngTemplateOutlet]="checkrideSkeleton"
                    [ngTemplateOutletContext]="{ compact: true }"></ng-container>
                <ng-container *ngIf="!checkridesLoading && !checkridesError">
                <div class="upcoming-list" *ngIf="upcomingCheckrides.length; else noUpcomingCheckrides">
                    <div class="upcoming-row" *ngFor="let card of upcomingCheckrides">
                        <span class="upcoming-date"><strong>{{card.day}}</strong><small>{{card.time}}</small></span>
                        <span class="upcoming-person"><strong *ngIf="card.applicantName">{{card.applicantName}}</strong><small *ngIf="card.upcomingSummary">{{card.upcomingSummary}}</small></span>
                        <span class="status-text" *ngIf="card.status">{{card.status}}</span>
                    </div>
                </div>
                <ng-template #noUpcomingCheckrides><p class="quiet-state">No checkrides scheduled in the next seven days.</p></ng-template>
                </ng-container>
            </section>
        </div>

        <aside class="side-column">
            <section class="dashboard-card tasks-card">
                <header class="section-header compact">
                    <div>
                        <p class="eyebrow">Action items</p>
                        <h2>Needs you</h2>
                    </div>
                    <span class="count-badge">{{attentionTaskCount}}</span>
                </header>

                <app-dashboard-task-list [tasks]="tasks"></app-dashboard-task-list>
            </section>

        </aside>
    </div>
</main>

<ng-template #checkrideSkeleton let-compact="compact">
    <div class="checkride-skeleton" [class.compact]="compact" role="status" aria-live="polite">
        <span class="sr-only">{{compact ? 'Loading upcoming checkrides' : 'Loading checkride details'}}</span>
        <div class="skeleton-row" *ngFor="let row of skeletonRows" aria-hidden="true">
            <div class="skeleton-date">
                <span class="skeleton-bone skeleton-time"></span>
                <span class="skeleton-bone skeleton-duration"></span>
            </div>
            <div class="skeleton-copy">
                <span class="skeleton-bone skeleton-name"></span>
                <span class="skeleton-bone skeleton-description"></span>
                <span class="skeleton-bone skeleton-detail" *ngIf="!compact"></span>
            </div>
            <span class="skeleton-bone skeleton-status"></span>
        </div>
    </div>
</ng-template>
